export default __webpack_public_path__ + "static/media/digital-wallet.9b30cc23.svg";